<div class="ballot-status {{status}} mb-2">{{ statusDisplay }}</div>
